import { StreamId } from "@common/domain";

export class MixerAudioStreamDeleteCmd {
  constructor(readonly streamId: StreamId) {}
}
